"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentDataWithEntries = void 0;
const AssignmentData_1 = require("./AssignmentData");
var AssignmentDataWithEntries;
(function (AssignmentDataWithEntries) {
    function from(assignmentData, entries) {
        if (!assignmentData) {
            return undefined;
        }
        return {
            assignmentData: assignmentData,
            entries: entries,
        };
    }
    AssignmentDataWithEntries.from = from;
    function isTest(data) {
        return AssignmentData_1.AssignmentData.isTest(data.assignmentData);
    }
    AssignmentDataWithEntries.isTest = isTest;
    function isRealtime(data) {
        return AssignmentData_1.AssignmentData.isRealtime(data.assignmentData);
    }
    AssignmentDataWithEntries.isRealtime = isRealtime;
    function isHomework(data) {
        return AssignmentData_1.AssignmentData.isHomework(data.assignmentData);
    }
    AssignmentDataWithEntries.isHomework = isHomework;
    function asTest(data) {
        return isTest(data) ? data : undefined;
    }
    AssignmentDataWithEntries.asTest = asTest;
    function asRealtime(data) {
        return isRealtime(data) ? data : undefined;
    }
    AssignmentDataWithEntries.asRealtime = asRealtime;
    function asHomework(data) {
        return isHomework(data) ? data : undefined;
    }
    AssignmentDataWithEntries.asHomework = asHomework;
})(AssignmentDataWithEntries || (exports.AssignmentDataWithEntries = AssignmentDataWithEntries = {}));
//# sourceMappingURL=AssignmentDataWithEntries.js.map